import * as React from 'react';
import { useAuth } from '../../../../App';
import { Modal, ModalBody, AlertMessage, AlertType, ModalSize, ModalFooter, CustomButton, ButtonType, CustomSubmitButton, Form } from 'soprasteria-ui-library';
import { OrthodonticReferralAdministrationApi } from '../../../../api/OrthodonticReferralAdministrationApi';

interface IOrthodonticReferralShareModal {
    orthodonticReferralId: number;
    renderForm: boolean;
    changeSuccessMessage: (message: string) => void;
    onFormClose: () => void;
    hasDecisionInterceptive: boolean;
    getOrthodonticReferral: (id: number) => void;
}

export const OrthodonticReferralShareModal: React.FunctionComponent<IOrthodonticReferralShareModal> = ({ orthodonticReferralId, renderForm, changeSuccessMessage, onFormClose, hasDecisionInterceptive, getOrthodonticReferral }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralAdministrationApi(auth);
    const [isSharing, setIsSharing] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [hasConfirmedTreatment, setHasConfirmedTreatment] = React.useState<boolean>(false);
    const [showConfirmTreatmentMsg, setShowConfirmTreamtmentMsg] = React.useState<boolean>(false);

    const shareOrthodonticReferral = () => {
        if (hasDecisionInterceptive) {
            setHasConfirmedTreatment(true);
        }
        setIsSharing(true);
        api.shareReferral(orthodonticReferralId, () => {
            changeSuccessMessage("Remissen delades");
            document.getElementById("close-share-orthodontic-referral-modal")?.click();
            getOrthodonticReferral(orthodonticReferralId);
        }, (msg) => {
            setErrorMessage(msg);
        }, () => setIsSharing(false))
    }

    const onClickForm = () => {
        if (hasDecisionInterceptive && !hasConfirmedTreatment) {
            setShowConfirmTreamtmentMsg(true);
        }
        else {
            shareOrthodonticReferral();
        }
    }

    const closeForm = () => {
        setShowConfirmTreamtmentMsg(false);
        onFormClose();
    }

    return (
        <>
            <Modal header="Dela ortodontiremiss" id="share-orthodontic-referral-modal" modalSize={ModalSize.large}>
                {
                    renderForm ?
                        <Form>
                            <ModalBody>
                                <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                                {
                                    !showConfirmTreatmentMsg ?
                                        <p>Är du säker på att du vill dela ortodontiremissen med patientens listningsansvariga vårdgivare?</p>
                                        : <p>Har du rapporterad all utförd vård på remissen? Ingen ytterligare vårdrapportering kan göras efter delning av remissen.</p>
                                }
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} buttonText={!showConfirmTreatmentMsg ? "Avbryt" : "Nej"}
                                    data-dismiss="modal" id="close-share-orthodontic-referral-modal" onClick={() => closeForm()} />
                                {!showConfirmTreatmentMsg ?
                                    <CustomSubmitButton onButtonSubmit={onClickForm} isLoading={isSharing}>Dela</CustomSubmitButton> :
                                    <CustomSubmitButton onButtonSubmit={shareOrthodonticReferral} isLoading={isSharing}>Ja</CustomSubmitButton>
                                }

                            </ModalFooter>
                        </Form>
                        : null
                }
            </Modal>
        </>
    )
}